export default __webpack_public_path__ + "static/media/inputs.sprite.eb2fa39a662c3d364113134954fd0337.svg";